import React, { useEffect, useState } from 'react';
import styles from './AccountUsersTable.module.scss';
import { $t } from "../../helpers/translator";
import api from "../../helpers/api";
import DataTable from "../miscellaneous/DataTable/DataTable";
import Timestamp from "../miscellaneous/Timestamp/Timestamp";
import Style from "../PatientsTable/Patients.module.scss";
import Modal from "../miscellaneous/Modal/Modal";
import AddAccountUser from "../AddAccountUser/AddAccountUser";
import { FaEdit } from "react-icons/fa";
import Tooltip from "../miscellaneous/Tooltip/Tooltip";
import DeleteAccountUser from "./DeleteAccountUser/DeleteAccountUser";
import HasPermission from 'helpers/permissions/HasPermission';

const AccountUsersTable = (props) => {
    const [ isTableLoading, setIsTableLoading ] = useState(false);
    const [ showAddEditUser, setShowAddEditUser ] = useState(false);
    const [ usersData, setUsersData ] = useState([]); //table of users' data
    const [ accountUserForEdit, setAccountUserForEdit ] = useState(null); //stores the user for edit
    const [ addUserKey, setAddUserKey ] = useState(0);    //used for reloading the component each time it is being closed
    const [ pagination, setPagination ] = useState({});

    useEffect(() => {
        getAccountUsers();
    }, [])

    useEffect(() => {
        if (accountUserForEdit) {
            setAddUserKey(addUserKey + 1)
            setShowAddEditUser(true);
        }
    }, [ accountUserForEdit ])

    useEffect(() => {
        if (!showAddEditUser) {
            setAccountUserForEdit(null);
        }
    }, [ showAddEditUser ])

    const getAccountUsers = async () => {
        setIsTableLoading(true);

        try {
            let res = await api.get('user');
            //console.log(res.data.data);
            if (!res || !res.success || !res.data || !res.data.success) {
                // console.log('errr')
                return;
            }

            setPagination(res.data.data.pagination)
            setUsersData(res.data.data.data);
        } catch (e) {
            console.error('err get platforms:', e);
        } finally {
            setIsTableLoading(false);
        }
    }

    const dataTableActionHandler = (data) => {
        // if (data.key === 'page') {
        //     setPayload({...payload, page: data.value});
        // } else if (data.key === 'header') {
        //     const newPayload = {...payload};
        //     if (payload.sort === data.value) {
        //         newPayload.order = payload.order === 'desc' ? 'asc' : 'desc'
        //     }
        //     newPayload.sort = data.value;
        //     setPayload(newPayload);
        // }
    }

    const closeModals = () => {
        setShowAddEditUser(false);
        setAccountUserForEdit(null);
        // setAddUserKey(addUserKey + 1);
    }

    let tableHeaders = [
        {
            name: $t('global.account.name'),
            id: 'name',
        },
        {
            name: $t('global.account.email'),
            id: 'email',
        },
        {
            name: $t('global.account.created_at'),
            id: 'created_at',
            render: (value) => {
                return <Timestamp time={ value } />
            }
        },
        {
            name: $t('global.account.subRole'),
            id: 'sub_role',
            render: (value) => {
                return <span>{ value ? value.charAt(0).toUpperCase() + value.slice(1) : '' }</span>
            }
        },
        {
            name: '',
            id: 'editable',
            render: (editable, row) => {
                return editable ?
                    <Tooltip content={ $t('global.account.editUser') }>
                        <FaEdit onClick={ () => {
                            setAccountUserForEdit(row);
                        } }
                            style={ { fontSize: '23px' } }
                            className={ `${styles.linkCursor}` } />
                    </Tooltip>
                    :
                    null
            }
        },
        {
            name: '',
            id: 'deletable',
            render: (deletable, row) => {
                return deletable ?
                    <Tooltip content={ $t('global.account.deleteUser') }>
                        <DeleteAccountUser id={ row.id }
                            name={ row.name }
                            style={ { fontSize: '20px' } }
                            onSuccess={ async () => await getAccountUsers() }
                        />
                    </Tooltip>
                    :
                    null
            }
        },
    ];


    return (
        <>
            <div className={ 'container' }>
                <div className={ 'box' }>
                    <div className={ 'alma-box' }>
                        <div className={ 'alma-box-header' }>
                            <div><h3>{ $t('global.account.accountUsers') }</h3></div>
                            <HasPermission permission="user.create">
                                <div className={ Style[ 'add-patient-button' ] }
                                    onClick={ () => {
                                        setAddUserKey(addUserKey + 1);
                                        setShowAddEditUser(true);
                                    } }>
                                    { $t('global.account.addAccountUser') }
                                </div>
                            </HasPermission>
                        </div>

                        <div>
                            <DataTable data={ usersData }
                                headers={ tableHeaders }
                                pagination={ pagination }
                                loading={ isTableLoading }
                                // sorted={tableSorted}
                                // apiUrl={getAPIUrl()}
                                onAction={ (e) => dataTableActionHandler(e) }
                            />
                        </div>

                        <Modal content={ <AddAccountUser user={ accountUserForEdit ? accountUserForEdit : null }
                            key={ addUserKey }
                            onSuccess={ async () => {
                                closeModals();
                                await getAccountUsers()
                            } } /> }
                            onClose={ (e) => {
                                closeModals(e)
                            } }
                            visible={ showAddEditUser }
                        />
                    </div>
                </div>
            </div>
        </>
    );
}

export default AccountUsersTable;

